import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class SduiNavigationService {
  constructor(private router: Router) {}

  navigateBySduiUrl(url: string): boolean {
    if (!url) return false;

    const normalized = this.normalizeUrl(url);
    if (!normalized) return false;

    const path = normalized.pathname.replace(/^\/+/, '');
    const queryParams = this.buildSduiQueryParams(normalized);

    // timeline post
    const timelineMatch = path.match(/^timeline\/([^/?#]+)/);
    if (timelineMatch) {
      const postId = timelineMatch[1];
      this.router.navigate(['comunidade', 'postagem', postId], { queryParams });
      return true;
    }

    // live
    const liveMatch = path.match(/^live\/([^/?#]+)/);
    if (liveMatch) {
      const liveId = liveMatch[1];
      this.router.navigate(['comunidade', 'postagem', 'live', liveId], { queryParams });
      return true;
    }

    // lessons: products/<id>/lessons/<id> ou product/<id>/lesson/<id>
    const lessonMatch =
      path.match(/^products\/([^/]+)\/lessons\/([^/?#]+)/) ||
      path.match(/^product\/([^/]+)\/lesson\/([^/?#]+)/) ||
      path.match(/^produtos\/([^/]+)\/aula\/([^/?#]+)/);
    if (lessonMatch) {
      const [, productId, lessonId] = lessonMatch;
      this.router.navigate(['produtos', productId, 'aula', lessonId], { queryParams });
      return true;
    }

    // product detail
    const productMatch = path.match(/^products\/([^/?#]+)/) || path.match(/^product\/([^/?#]+)/);
    if (productMatch) {
      const productId = productMatch[1];
      this.router.navigate(['produtos', productId], { queryParams });
      return true;
    }

    // posts
    const postsMatch = path.match(/^posts\/([^/?#]+)/);
    if (postsMatch) {
      const postId = postsMatch[1];
      this.router.navigate(['comunidade', 'postagem', postId], { queryParams });
      return true;
    }

    const profileRoutes = new Map<string, string[]>([
      ['my-purchases', ['perfil', 'compras']],
      ['my-annotations', ['perfil', 'meu-caderno']],
      ['my-list', ['perfil', 'minha-lista']],
      ['my-certificates', ['perfil', 'certificados']],
      ['my-subscriptions', ['perfil', 'assinaturas']],
      ['edit-profile', ['perfil', 'editar']],
      ['ranking/rules', ['perfil', 'ranking', 'regras']],
      ['ranking', ['perfil', 'ranking']],
      ['logout', ['logout']],
    ]);

    for (const [key, route] of profileRoutes.entries()) {
      if (url.includes(key)) {
        this.router.navigate(route, { queryParams });
        return true;
      }
    }

    return false; // nenhum dos casos foi tratado
  }

  private buildSduiQueryParams(normalized: URL): Record<string, any> {
    const existing = Object.fromEntries(normalized.searchParams.entries());
    const params: Record<string, any> = {
      from: 'sdui',
      ...existing,
    };

    if (this.router.url.startsWith('/explorar')) {
      params.explorer = 'true';
    }

    return params;
  }

  private normalizeUrl(url: string): URL | null {
    let raw = url.trim();
    // remove prefix edm:// se existir
    if (raw.startsWith('edm://')) {
      raw = raw.replace(/^edm:\/\//, '');
    } else if (raw.startsWith('edm:')) {
      raw = raw.replace(/^edm:/, '');
    }

    // se for edm://sdui?url=..., já vem decodificado pelo core; aqui só tratamos links absolutos/relativos
    try {
      if (raw.startsWith('http')) {
        return new URL(raw);
      }
      // trata como relativo ao host atual para conseguir pathname
      return new URL(raw, window.location.origin);
    } catch (e) {
      return null;
    }
  }
}
